import React from 'react';

function MarkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="22"
      fill="none"
      viewBox="0 0 26 22"
    >
      <path
        fill="#27AAE1"
        d="M8.64 3.781C8.876 1.906 10.423.5 12.345.5c2.203 0 3.937 1.969 3.703 4.219l-.61 4.547c-.234 1.875-1.78 3.234-3.703 3.234-2.203 0-3.984-1.969-3.703-4.172l.61-4.547zm3.704-.281a.758.758 0 00-.75.656l-.563 4.547a.715.715 0 00.703.797c.375 0 .704-.234.75-.61l.563-4.546c.047-.422-.281-.844-.703-.844zm-6.516 9.188c-.094.843-.89 1.406-1.687 1.312-.844-.094-1.407-.844-1.266-1.688L4 4.484l-.938.422c-.75.328-1.64 0-1.968-.75-.328-.797.047-1.64.797-2.015L5.266.64C5.78.453 6.344.5 6.766.828c.421.328.656.844.562 1.406l-1.5 10.454zm19.125 1.124a1.453 1.453 0 01-1.265 1.688l-21 3c-.797.14-1.594-.469-1.688-1.266-.14-.843.422-1.593 1.266-1.687l21-3a1.453 1.453 0 011.687 1.265zm0 4.5A1.453 1.453 0 0123.688 20l-10.5 1.5c-.797.14-1.594-.469-1.688-1.266-.14-.843.422-1.593 1.266-1.687l10.5-1.5a1.453 1.453 0 011.687 1.265zm-.187-13.734l-.375 3.797c-.141 1.922-1.782 3.375-3.703 3.375a3.757 3.757 0 01-3.75-4.078l.375-3.75C17.453 2 19.093.5 21.015.5c2.203 0 3.937 1.922 3.75 4.078zm-4.828 3.375c-.047.422.328.797.75.797a.758.758 0 00.75-.656l.328-3.75a.766.766 0 00-.75-.844c-.375 0-.703.328-.75.703l-.328 3.75z"
      ></path>
    </svg>
  );
}

function GaugeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#27AAE1"
        d="M24 12c0 6.656-5.39 12-12 12-6.656 0-12-5.344-12-12C0 5.39 5.344 0 12 0c6.61 0 12 5.39 12 12zm-10.875 1.734V4.125A1.14 1.14 0 0012 3a1.11 1.11 0 00-1.125 1.125v9.61C9.75 14.202 9 15.28 9 16.5c0 1.688 1.313 3 3 3 1.64 0 3-1.313 3-3 0-1.219-.797-2.297-1.875-2.766zM6.75 8.25c.797 0 1.5-.656 1.5-1.5 0-.797-.703-1.5-1.5-1.5-.844 0-1.5.703-1.5 1.5 0 .844.656 1.5 1.5 1.5zM4.5 10.5c-.844 0-1.5.703-1.5 1.5 0 .844.656 1.5 1.5 1.5.797 0 1.5-.656 1.5-1.5 0-.797-.703-1.5-1.5-1.5zm15 3c.797 0 1.5-.656 1.5-1.5 0-.797-.703-1.5-1.5-1.5-.844 0-1.5.703-1.5 1.5 0 .844.656 1.5 1.5 1.5zm-2.25-8.25c-.844 0-1.5.703-1.5 1.5 0 .844.656 1.5 1.5 1.5.797 0 1.5-.656 1.5-1.5 0-.797-.703-1.5-1.5-1.5z"
      ></path>
    </svg>
  );
}

function HourglassIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="24"
      fill="none"
      viewBox="0 0 18 24"
    >
      <path
        fill="#27AAE1"
        d="M16.5 0c.797 0 1.5.703 1.5 1.5 0 .844-.703 1.5-1.5 1.5v.516a7.555 7.555 0 01-2.203 5.343L11.109 12l3.188 3.188a7.528 7.528 0 012.203 5.296V21c.797 0 1.5.703 1.5 1.5 0 .844-.703 1.5-1.5 1.5h-15A1.48 1.48 0 010 22.5c0-.797.656-1.5 1.5-1.5v-.516c0-1.968.75-3.89 2.156-5.297L6.844 12 3.656 8.86C2.25 7.452 1.5 5.53 1.5 3.515V3A1.48 1.48 0 010 1.5C0 .703.656 0 1.5 0h15zm-4.36 17.344L9 14.156l-3.188 3.188a4.437 4.437 0 00-1.312 3.14V21h9v-.516c0-1.172-.516-2.297-1.36-3.14z"
      ></path>
    </svg>
  );
}

const CalculateSkillLevelInfo = () => {
  return (
    <div
      className={"text-neutral-pencil text-center font-['Open_Sans'] pb-[8px]"}
    >
      <div
        className={
          'flex w-100 mt-[20px] mb-[16px] text-[14px] font-bold leading-[19px]'
        }
      >
        <h1>
          Designed to correlate with exam scores, Skill levels is calculated
          based on several factors:
        </h1>
      </div>
      <div className={'flex w-100 mb-[16px]'}>
        <div className={'inline-flex w-2/12 max-w-[40px]'}>
          <h1>
            <MarkIcon />
          </h1>
        </div>
        <div className={'inline-flex w-11/12'}>
          <div className={'flex-col text-left text-[14px] leading-[19px]'}>
            <h1 className={'w-full font-bold'}>Marks obtained</h1>
            <p className={'w-full mt-[4px]'}>
              The more marks you score, the higher your skill levels for a
              particular topic.
            </p>
          </div>
        </div>
      </div>
      <div className={'flex w-100 mb-[16px]'}>
        <div className={'inline-flex w-2/12 max-w-[40px]'}>
          <h1>
            <GaugeIcon />
          </h1>
        </div>
        <div className={'inline-flex w-11/12'}>
          <div className={'flex-col text-left text-[14px] leading-[19px]'}>
            <h1 className={'w-full font-bold'}>
              Difficulty level of questions
            </h1>
            <p className={'w-full mt-[4px]'}>
              Difficult questions carry greater weight and help you achieve
              higher skill levels, as opposed to easy questions.
            </p>
          </div>
        </div>
      </div>
      <div className={'flex w-100 mb-[16px]'}>
        <div className={'inline-flex w-2/12 max-w-[40px]'}>
          <h1>
            <HourglassIcon />
          </h1>
        </div>
        <div className={'inline-flex w-11/12'}>
          <div className={'flex-col text-left text-[14px] leading-[19px]'}>
            <h1 className={'w-full font-bold'}>Recency of topic practiced</h1>
            <p className={'w-full mt-[4px]'}>
              As we forget things overtime, skill levels drop after 6 months of
              inactivity. The most recent 40 - 50 marks of each topic will be
              factored into your skill level.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalculateSkillLevelInfo;
